"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var Services_1 = require("../../../../../../Services");
var Types_1 = require("../../../../../../Types");
require("../Styles/OrganisationRegistrationForm.css");
var Endpoints_1 = require("../../../../../../Utils/Endpoints");
var OrganisationRegistrationFormStatus;
(function (OrganisationRegistrationFormStatus) {
    OrganisationRegistrationFormStatus[OrganisationRegistrationFormStatus["Initial"] = 0] = "Initial";
    OrganisationRegistrationFormStatus[OrganisationRegistrationFormStatus["Loading"] = 1] = "Loading";
    OrganisationRegistrationFormStatus[OrganisationRegistrationFormStatus["Error"] = 2] = "Error";
})(OrganisationRegistrationFormStatus || (OrganisationRegistrationFormStatus = {}));
var OrganisationRegistrationForm = /** @class */ (function (_super) {
    __extends(OrganisationRegistrationForm, _super);
    function OrganisationRegistrationForm(props) {
        var _this = _super.call(this, props) || this;
        _this.captchaValidationKey = "captcha";
        _this.validate = function (ref, regex, invalidErrorMessage) {
            var validation = _this.state.validation;
            var value = Services_1.getValueFromInputRef(ref);
            var name = Services_1.getNameFromInputRef(ref);
            if (!!value) {
                if (!regex.test(value)) {
                    validation[name] = { isValid: false, reason: invalidErrorMessage };
                }
                else {
                    validation[name] = { isValid: true, reason: "" };
                }
            }
            else {
                validation[name] = { isValid: false, reason: _this.props.resources.Registration_Validation_RequiredField };
            }
            _this.setState({ validation: validation });
            return validation[name].isValid;
        };
        _this.validateOrganisation = function () {
            _this.validate(_this.orgNameInputRef, /^([A-Za-z0-9-]\s?){1,}$/, _this.props.resources.Registration_Validation_InvalidOrganisationId);
        };
        _this.validateEmail = function () {
            _this.validate(_this.emailInputRef, /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/, _this.props.resources.Registration_Validation_EmailIsNotValid);
        };
        _this.validateDisplayName = function () {
            _this.validate(_this.displayNameInputRef, /^\S+.{1,}\S$/, _this.props.resources.InvalidDisplayName);
        };
        _this.passwordValidation = function (thisPasswordRef, otherPasswordRef) {
            var _a, _b;
            var thisPassword = Services_1.getValueFromInputRef(thisPasswordRef);
            var otherPassword = Services_1.getValueFromInputRef(otherPasswordRef);
            if (!!thisPassword && !!otherPassword) {
                if (thisPassword == otherPassword) {
                    if (_this.validate(thisPasswordRef, _this.passwordRegex, _this.props.resources.Registration_Validation_Password.replace("\\\\", "\\").replace("\\\"", "\""))) {
                        _this.validate(otherPasswordRef, _this.passwordRegex, _this.props.resources.Registration_Validation_Password.replace("\\\\", "\\").replace("\\\"", "\""));
                    }
                    else {
                        //if passwords match but are invalid clear validation on the other password field so as not to clutter the ui with duplicate/inaccurate errors
                        _this.setState({
                            validation: __assign(__assign({}, _this.state.validation), (_a = {}, _a[Services_1.getNameFromInputRef(otherPasswordRef)] = { isValid: true, reason: "" }, _a))
                        });
                    }
                }
                else {
                    _this.setState({
                        validation: __assign(__assign({}, _this.state.validation), (_b = {}, _b[Services_1.getNameFromInputRef(thisPasswordRef)] = {
                            isValid: false,
                            reason: _this.props.resources.Registration_Validation_PasswordsDoNotMatch
                        }, _b[Services_1.getNameFromInputRef(otherPasswordRef)] = { isValid: true, reason: "" }, _b))
                    });
                }
            }
            else {
                _this.validate(thisPasswordRef, _this.passwordRegex, _this.props.resources.Registration_Validation_Password.replace("\\\\", "\\").replace("\\\"", "\""));
            }
        };
        _this.validatePassword = function () {
            _this.passwordValidation(_this.passwordInputRef, _this.confirmPasswordInputRef);
        };
        _this.validateConfirmPassword = function () {
            _this.passwordValidation(_this.confirmPasswordInputRef, _this.passwordInputRef);
        };
        _this.checkValidation = function () {
            var validationResult = true;
            for (var key in _this.state.validation) {
                validationResult = _this.state.validation[key].isValid && validationResult;
            }
            return validationResult;
        };
        _this.allFieldsHaveValues = function () {
            var result = true;
            result = result && Services_1.getValueFromInputRef(_this.orgNameInputRef) != "";
            result = result && Services_1.getValueFromInputRef(_this.emailInputRef) != "";
            result = result && Services_1.getValueFromInputRef(_this.displayNameInputRef) != "";
            result = result && Services_1.getValueFromInputRef(_this.passwordInputRef) != "";
            result = result && Services_1.getValueFromInputRef(_this.confirmPasswordInputRef) != "";
            result = result && _this.tryGetRecaptchaResponse().success;
            if (_this.state.status == OrganisationRegistrationFormStatus.Error && result) {
                _this.setState({ status: OrganisationRegistrationFormStatus.Initial });
            }
            return result;
        };
        _this.tryGetRecaptchaResponse = function () {
            var success = false;
            var result = null;
            try {
                result = window.grecaptcha.getResponse();
                success = result != "";
            }
            catch (e) {
                success = false;
            }
            return { success: success, result: result };
        };
        _this.handleSubmit = function (event) {
            event.preventDefault();
            if (!_this.allFieldsHaveValues()) {
                return;
            }
            var recaptcha = _this.tryGetRecaptchaResponse();
            window.grecaptcha.reset();
            _this.setState({ status: OrganisationRegistrationFormStatus.Loading });
            var body = JSON.stringify({
                OrganisationId: Services_1.getValueFromInputRef(_this.orgNameInputRef),
                AdminEmail: Services_1.getValueFromInputRef(_this.emailInputRef),
                AdminDisplayName: Services_1.getValueFromInputRef(_this.displayNameInputRef),
                UserRole: "",
                Password: Services_1.getValueFromInputRef(_this.passwordInputRef),
                ConfirmPassword: Services_1.getValueFromInputRef(_this.confirmPasswordInputRef),
                ReCaptcha: recaptcha.result
            });
            Services_1.postJson(Endpoints_1.default.RegisterOrganisation, body, undefined, false, undefined, true).then(function (r) {
                if (r) {
                    _this.props.onRegisterComplete();
                }
                else {
                    _this.appError = _this.props.resources.SomethingWentWrong;
                    _this.setState({ status: OrganisationRegistrationFormStatus.Error });
                }
            }).catch(function (e) {
                if (e.AppError != undefined) {
                    _this.appError = e.AppError[0];
                }
                else {
                    console.error(e);
                    _this.appError = _this.props.resources.SomethingWentWrong;
                }
                _this.setState({ status: OrganisationRegistrationFormStatus.Error });
            });
        };
        _this.state = {
            validation: {
                organisationName: Types_1.DefaultValidationResult,
                email: Types_1.DefaultValidationResult,
                displayName: Types_1.DefaultValidationResult,
                password: Types_1.DefaultValidationResult,
                confirmPassword: Types_1.DefaultValidationResult,
                captcha: Types_1.DefaultValidationResult
            },
            status: OrganisationRegistrationFormStatus.Initial
        };
        _this.orgNameInputRef = React.createRef();
        _this.emailInputRef = React.createRef();
        _this.displayNameInputRef = React.createRef();
        _this.passwordInputRef = React.createRef();
        _this.confirmPasswordInputRef = React.createRef();
        _this.passwordRegex = /^((?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])|(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[^a-zA-Z0-9])|(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])|(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^a-zA-Z0-9])).{8,16}$/;
        _this.captchaSiteKey = process.env.REACT_APP_CAPTCHASITEKEY;
        _this.appError = "";
        // Initialize reCAPTCHA handlers
        window.verilite_registration_captcha_callback = function () {
            var _a;
            _this.setState({ validation: __assign(__assign({}, _this.state.validation), (_a = {}, _a[_this.captchaValidationKey] = { isValid: true, reason: "" }, _a)) });
        };
        window.verilite_registration_captcha_expired_callback = function () {
            var _a;
            _this.setState({ validation: __assign(__assign({}, _this.state.validation), (_a = {}, _a[_this.captchaValidationKey] = { isValid: false, reason: _this.props.resources.Registration_Validation_RecaptchaExpired }, _a)) });
        };
        return _this;
    }
    OrganisationRegistrationForm.prototype.render = function () {
        var _a, _b, _c, _d, _e;
        return (React.createElement(reactstrap_1.Form, { onSubmit: this.handleSubmit },
            React.createElement(reactstrap_1.FormGroup, null,
                React.createElement(reactstrap_1.Label, { for: "organisationName" }, (_a = this.props.resources) === null || _a === void 0 ? void 0 : _a.Registration_OrganisationId),
                React.createElement(reactstrap_1.Input, { type: "text", name: "organisationName", id: "organisationName", innerRef: this.orgNameInputRef, onBlur: this.validateOrganisation, invalid: !this.state.validation.organisationName.isValid }),
                React.createElement(reactstrap_1.FormFeedback, { tooltip: true, className: "invalid-tooltip-relative" }, this.state.validation.organisationName.reason)),
            React.createElement(reactstrap_1.FormGroup, null,
                React.createElement(reactstrap_1.Label, { for: "email" }, (_b = this.props.resources) === null || _b === void 0 ? void 0 : _b.Registration_Email),
                React.createElement(reactstrap_1.Input, { type: "email", name: "email", id: "email", innerRef: this.emailInputRef, onBlur: this.validateEmail, invalid: !this.state.validation.email.isValid }),
                React.createElement(reactstrap_1.FormFeedback, { tooltip: true, className: "invalid-tooltip-relative" }, this.state.validation.email.reason)),
            React.createElement(reactstrap_1.FormGroup, null,
                React.createElement(reactstrap_1.Label, { for: "displayName" }, (_c = this.props.resources) === null || _c === void 0 ? void 0 : _c.Registration_DisplayName),
                React.createElement(reactstrap_1.Input, { type: "text", name: "displayName", id: "displayName", innerRef: this.displayNameInputRef, onBlur: this.validateDisplayName, invalid: !this.state.validation.displayName.isValid }),
                React.createElement(reactstrap_1.FormFeedback, { tooltip: true, className: "invalid-tooltip-relative" }, this.state.validation.displayName.reason)),
            React.createElement(reactstrap_1.FormGroup, null,
                React.createElement(reactstrap_1.Label, { for: "password" }, (_d = this.props.resources) === null || _d === void 0 ? void 0 : _d.Registration_Password),
                React.createElement(reactstrap_1.Input, { type: "password", name: "password", id: "password", innerRef: this.passwordInputRef, onBlur: this.validatePassword, invalid: !this.state.validation.password.isValid }),
                React.createElement(reactstrap_1.FormFeedback, { tooltip: true, className: "invalid-tooltip-relative" }, this.state.validation.password.reason)),
            React.createElement(reactstrap_1.FormGroup, null,
                React.createElement(reactstrap_1.Label, { for: "confirmPassword" }, (_e = this.props.resources) === null || _e === void 0 ? void 0 : _e.Registration_ConfirmPassword),
                React.createElement(reactstrap_1.Input, { type: "password", name: "confirmPassword", id: "confirmPassword", innerRef: this.confirmPasswordInputRef, onBlur: this.validateConfirmPassword, invalid: !this.state.validation.confirmPassword.isValid }),
                React.createElement(reactstrap_1.FormFeedback, { tooltip: true, className: "invalid-tooltip-relative" }, this.state.validation.confirmPassword.reason)),
            this.state.status == OrganisationRegistrationFormStatus.Loading &&
                React.createElement("div", { className: "organisation-registration-form-spinner-container mt-4" },
                    React.createElement(reactstrap_1.Spinner, { style: { width: '3rem', height: '3rem' }, color: "light" }),
                    React.createElement("span", { className: "my-2" }, this.props.resources.Registration_WorkingOnIt)),
            React.createElement("div", null,
                React.createElement(reactstrap_1.FormGroup, { style: this.state.status == OrganisationRegistrationFormStatus.Loading ? { display: "none" } : { display: "block" } },
                    React.createElement("div", { className: "g-recaptcha", "data-sitekey": this.captchaSiteKey, "data-callback": "verilite_registration_captcha_callback", "data-expired-callback": "verilite_registration_captcha_expired_callback" }),
                    this.state.status == OrganisationRegistrationFormStatus.Error && React.createElement(reactstrap_1.FormFeedback, { tooltip: true, className: "invalid-tooltip-relative", style: { display: "block" } }, this.appError)),
                this.state.status != OrganisationRegistrationFormStatus.Loading &&
                    React.createElement(reactstrap_1.Button, { outline: true, color: "light", className: "float-right " + (this.allFieldsHaveValues() && this.checkValidation() ? "" : "disabled") }, this.props.resources.Submit))));
    };
    return OrganisationRegistrationForm;
}(React.Component));
exports.OrganisationRegistrationForm = OrganisationRegistrationForm;
//# sourceMappingURL=OrganisationRegistrationForm.js.map